// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1Z2fn","row":"Node_row___mHS0","label":"Node_label__2we6N","footer":"Node_footer__3QOx0"};